module.exports = __webpack_public_path__ + "img/HA1504-25.0d4821db.jpg";